export const KEYBOARD_SHORTCUTS = [
  { keys: 'Ctrl/Cmd + K', action: 'Search pages and tasks' },
  { keys: 'Ctrl/Cmd + N', action: 'Create a new task' },
  { keys: '?', action: 'Show keyboard shortcuts' },
  { keys: 'Enter', action: 'Send a chat message' },
  { keys: 'Shift + Enter', action: 'New line in chat' }
];

export function isEditableKeyTarget(target) {
  if (!target) return false;
  const tag = target.tagName;
  return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || Boolean(target.isContentEditable);
}
